import React, { useEffect, useRef, useState } from 'react';
import { Link as ScrollLink, scroller } from 'react-scroll';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import logo from '../assets/logo192.png'; // Adjust the path as needed

const NAV_LINKS = [
  { label: 'Features', to: '/features', type: 'page' },
  { label: 'About', to: '/about', type: 'page' },
  { label: 'How It Works', to: 'how-it-works', type: 'scroll' },
  { label: 'Services', to: 'services', type: 'scroll' },
  { label: 'Pricing', to: 'pricing', type: 'scroll' },
  { label: 'Contact', to: 'contact', type: 'scroll' }
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [outlined, setOutlined] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    function handleScroll() {
      // Check if the navbar is below the hero section
      const hero = document.getElementById('home');
      const navbar = navbarRef.current;
      if (!hero || !navbar) return;
      const heroRect = hero.getBoundingClientRect();
      const navbarRect = navbar.getBoundingClientRect();
      // If the navbar's bottom is below the hero's bottom, add outline
      if (navbarRect.top > heroRect.bottom - 10) {
        setOutlined(true);
      } else {
        setOutlined(false);
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (section) => (e) => {
    if (location.pathname === '/') {
      scroller.scrollTo(section, {
        smooth: true,
        offset: -80,
        duration: 500,
      });
    } else {
      e.preventDefault();
      navigate('/', { replace: false });
      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          offset: -80,
          duration: 500,
        });
      }, 100);
    }
  };

  const handleLogoClick = (e) => {
    if (location.pathname === '/') {
      scroller.scrollTo('home', { smooth: true, duration: 500 });
    } else {
      e.preventDefault();
      navigate('/', { replace: false });
      setTimeout(() => {
        scroller.scrollTo('home', { smooth: true, duration: 500 });
      }, 100);
    }
  };

  return (
    <nav
      ref={navbarRef}
      className={`${styles.navbar} ${outlined ? styles.outlined : ''}`}
    >
      {/* Left: Logo, Title, and Nav Links */}
      <div className={styles.left}>
        <a href="/" className={styles.logoLink} onClick={handleLogoClick}>
          <div className={styles.logo}>
            <img src={logo} alt="Logo" className={styles.logoImg} />
            MusicTeachers.ai
          </div>
        </a>
        <ul className={styles.navLinks}>
          {NAV_LINKS.map(link => (
            <li key={link.to}>
              {link.type === 'page' ? (
                <Link to={link.to} className={styles.navLink}>
                  {link.label}
                </Link>
              ) : (
                <a
                  href={`/#${link.to}`}
                  className={styles.navLink}
                  onClick={handleNavClick(link.to)}
                >
                  {link.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
      {/* Right: CTA Button */}
      <div className={styles.right}>
        <a
          href="/#pricing"
          className={styles.ctaButton}
          onClick={handleNavClick('pricing')}
        >
          ▶ Work With Us Today
        </a>
      </div>
    </nav>
  );
};

export default Navbar;